import { Outlet } from 'react-router-dom';
import SideNav from '../Layout/SideNav/SideNav';
import './Home.scss';

const Home = () => {
    return (
        <div className="home">
            <SideNav />
            <div className="home__content">
                <Outlet />
            </div>
        </div>
    );
};

export default Home;
